import { aggregateProductsQuantities } from "../../Common/utils/func.util";

export function gatherIntegratedDrivesProductsForBOM(axes) {
  // console.log("gatherRetrofitProductsForBOM", axes);
  const tmpProduct = [];
  axes?.forEach((axis) => {
    const gearboxReference = axis.bundle?.gearbox?.commercialReference;
    const adaptationKitReference = axis.bundle?.adaptationKit?.commercialReference;
    if (gearboxReference)
      tmpProduct.push({ commercialReference: gearboxReference, quantity: 1, axis: axis.id, type: "Gearbox" });
    if (adaptationKitReference)
      tmpProduct.push({ commercialReference: adaptationKitReference, quantity: 1, axis: axis.id, type: "Kit" });
  });
  return aggregateProductsQuantities(tmpProduct);
}
